import React from 'react';
import { useIntl } from 'react-intl';

const LoadingSmall = () => {
  const intl = useIntl();
  return (
    <div className="loader-small">
      <div className="loader">
        {intl.formatMessage({
          defaultMessage: 'Loading...',
        })}
      </div>
    </div>
  );
};

export default LoadingSmall;
